import { services } from '../services';
var action = "sale";

export const saleService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    saledetail,
    saleschedule,
    getOneByProperty,
    getListByCustomer,
    pay,
    addCommission,
    getSaleByProperty,
    removeByProperty,
    notation
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getOneByProperty(id) {
    return services.restApi(`${action}/property/${id}`, 'GET');
}

function getListByCustomer(id) {
    return services.restApi(`sale-customer/${id}`, 'GET');
}

function saledetail(id, object = {}) {
    return services.restApi(`salepaymentschedule/saledetail/${id}`, 'GET', object);
}
function saleschedule(id) {
    return services.restApi(`salepaymentschedule/saleschedule/${id}`, 'GET');
}
function pay(id) {
    return services.restApi(`salepaymentschedule/pay/${id}`, 'GET');
}

function addCommission(id, object) {
    return services.restApi(`${action}/commission/${id}`, 'PUT', object);
}

function getSaleByProperty(id) {
    return services.restApi(`cancelation/sale/${id}`, 'GET');
}

function removeByProperty(id) {
    return services.restApi(`${action}/property/${id}`, 'DELETE');
}

function notation(object) {
    return services.restApi(`salepaymentschedule/notation/`, 'POST', object);
}